module.exports = __webpack_public_path__ + "img/icon1.8597f5e2.png";